module.exports = __webpack_public_path__ + "img/rain-night.330064e4.jpeg";